﻿export interface IClcChainStarters {
    id: number;
    donorAlias: string;
    donorType: string;
    donorABO: string;
    recipientAlias: string;
    txpDate: string;
    clcPoints: number;
}
